import { Route } from "react-router-dom";

import Policy from "../pages/Policy/Policy";

export const policy = <Route path="policy" element={<Policy />} />;
